import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/voila-board`;

class VoilaBoardService {
  // ── Board CRUD ──
  listBoards = (enquiryId: number) =>
    myAxios.get<any>(`${BASE}/boards`, { params: { enquiryId } });

  getBoard = (boardId: number) =>
    myAxios.get<any>(`${BASE}/boards/${boardId}`);

  createBoard = (body: { enquiryId: number; enrollmentId?: number; title?: string; description?: string }) =>
    myAxios.post<any>(`${BASE}/boards`, body);

  updateBoard = (boardId: number, body: { title?: string; description?: string; coverImageUrl?: string; themeConfig?: any }) =>
    myAxios.put<any>(`${BASE}/boards/${boardId}`, body);

  deleteBoard = (boardId: number) =>
    myAxios.delete<any>(`${BASE}/boards/${boardId}`);

  // ── Item CRUD ──
  addItem = (boardId: number, body: {
    itemType: string;
    title?: string;
    description?: string;
    eventDate?: string;
    studyResourceId?: number;
    mediaUrl?: string;
    thumbnailUrl?: string;
    youTubeUrl?: string;
    isPinned?: boolean;
    sortOrder?: number;
  }) => myAxios.post<any>(`${BASE}/boards/${boardId}/items`, body);

  updateItem = (boardId: number, itemId: number, body: any) =>
    myAxios.put<any>(`${BASE}/boards/${boardId}/items/${itemId}`, body);

  deleteItem = (boardId: number, itemId: number) =>
    myAxios.delete<any>(`${BASE}/boards/${boardId}/items/${itemId}`);

  // ── Upload ──
  uploadMedia = (boardId: number, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return myAxios.post<any>(`${BASE}/boards/${boardId}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  // ── Auto-populate ──
  autoPopulate = (boardId: number) =>
    myAxios.post<any>(`${BASE}/boards/${boardId}/auto-populate`);

  // ── Share settings ──
  updateShareSettings = (boardId: number, body: { isPublished?: boolean; sharePIN?: string | null; shareExpiryDate?: string | null }) =>
    myAxios.put<any>(`${BASE}/boards/${boardId}/share`, body);
}

export default new VoilaBoardService();
